import client from 'common/admin/client'

export const postCommunity = community =>
  client.post('communities', { body: { ...community } })

export const fetchCommunity = id => client.get(`communities/${id}`)

export const updateCommunity = (id, community) =>
  client.patch(`communities/${id}`, { body: { ...community } })

export const fetchCommunities = () => client.get('communities')

export const destroyCommunity = id => client.del(`communities/${id}`)
